<template>
	<div>
		<p>
			Дарим бесплатную годовую парковку на Кампусе участникам программы лояльности при взносе:
		</p>
		<ul class="mb-3">
			<li
				v-for="freeParkingLevel in freeParkingLevels"
				:key="freeParkingLevel.id"
				:style="freeParkingLevel.isCustomerLevel ? 'font-weight : bolder' : ''"
			>
				уровень участия {{ freeParkingLevel.name }} - от {{ freeParkingLevel.donation }} рублей
			</li>
		</ul>

		<FormulateInput
			v-model="wantFreeParking"
			type="checkbox"
			name="want_free_parking"
			:disabled="! freeParkingEnabled()"
			:input-class="'formulate-input-hidden-checkbox'"
		>
			<template #label="{ id }">
				<label
					:for="id"
					class="ml-2"
					:class="{'text-secondary': ! freeParkingEnabled()}"
				>
					Получить бесплатную парковку
					на Кампусе на 1 год
				</label>
			</template>
		</FormulateInput>
		<template v-if="freeParkingEnabled() && wantFreeParking">
			<FormulateInput
				v-model="carNumber"
				name="car_number"
				type="text"
				class="col-12 mb-3"
				placeholder="Номер авто"
				validation="required"
				validation-name="Номер авто"
				:validation-messages="{
					'required': 'обязательно к заполнению'
				}"
			/>

			<FormulateInput
				v-model="haveFreeParkingPass"
				name="have_free_parking_pass"
				:options="[
					{value: 1, label: 'Есть'},
					{value: 0, label: 'Нет'}
				]"
				label="Пропуск на Кампус"
				type="radio"
				class="col-12 mb-3"
				validation="required|min:1,length"
				validation-name="Пропуск на Кампус"
				:validation-messages="{
					'required': 'обязательно к заполнению',
					'min': ''
				}"
			/>
		</template>
	</div>
</template>

<script>
export default {
	name: 'FreeParkingFieldGroup',
	data() {
		return {
			wantFreeParking: false,
			carNumber: '',
			haveFreeParkingPass: null,
			neededAmountForFreeParking: null,
			freeParkingLevels: [],
		};
	},
	computed: {
		donationValue() {
			return parseFloat(this.$parent.formulateValue.donation_amount);
		},
		isLogged() {
			return this.$auth.loggedIn;
		},
	},
	watch: {
		donationValue: function donationValue() {
			if (! this.freeParkingEnabled()) {
				this.wantFreeParking = false;
			}
		},
		isLogged: function isLogged(newValue, oldValue) {
			if (newValue && ! oldValue) {
				this.loadFreeParkingLevels();
			}
		},
	},
	mounted() {
		this.loadFreeParkingLevels();
	},
	methods: {
		freeParkingEnabled() {
			const amount = Number(this.donationValue || 0);

			return this.neededAmountForFreeParking !== null && amount >= this.neededAmountForFreeParking;
		},
		async loadFreeParkingLevels() {
			const {
				data: levels,
				customer_level: customerLevel,
			} = await this.$api.getLoyaltyLevels();

			this.freeParkingLevels = levels.filter((item) => item.free_parking_donation)
				.map((item) => ({
					name: item.name,
					donation: Number(item.free_parking_donation).toLocaleString(),
					isCustomerLevel: customerLevel === item.id,
				}));

			if (customerLevel) {
				const freeParkingDonation = levels.find((item) => item.id === customerLevel)
					?.free_parking_donation ?? null;

				if (freeParkingDonation) {
					this.neededAmountForFreeParking = Number(freeParkingDonation);
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
